var exports = {
  "K": "x28a7bf27--3b17df--video",
};

module.exports = exports;
